import React from "react";
import { LogoContainer } from "../LogoContainer"
import { ActionLink } from "../ActionLink"
import TextInput from "../TextInput"
import { Submit } from "../Submit"
import styles from "../Form/Form.module.scss";

export interface ResetPasswordFormProps {
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    is_pending: boolean;
    error?: string;
}

export const ResetPasswordForm = (props: ResetPasswordFormProps) => {
    return (
        <div className={styles.fullform}>
            <LogoContainer />

            {props.error && (
                <p><span className="form-error">{props.error}</span></p>
            )}

            <form onSubmit={props.onSubmit}>
                <TextInput
                    name="email"
                    onChange={props.onChange}
                    placeholder="email"
                    help="Enter Your Email" />

                <Submit label="Reset" is_pending={props.is_pending}/>
            </form>

            <ActionLink to="/dashboard/login">
                cancel
            </ActionLink>
        </div>
    );
};

export default ResetPasswordForm;
